module.exports = __webpack_public_path__ + "img/cp1-3.e4658c05.jpg";